import { Button, Drawer } from "antd";
import { useState } from "react";
import { trackEvent } from "../../../../utils/helper";
import dayjs from "dayjs";
import {
  getLocalStorage,
  setLocalStorage,
} from "../../../../utils/localStorage";
import {
  LANGUAGE,
  languageOptions,
  MOBILE_NUMBER,
} from "../../../symptomCollector/utils/constants";
import { useLocation } from "react-router-dom";

const SelectLanguageDrawer = ({
  selectedLanguage,
  setSelectedLanguage,
}: any) => {
  const phoneNumber = getLocalStorage(MOBILE_NUMBER);
  const location = useLocation();
  const { state } = location;
  const { agentDetails } = state || {};
  const [pendingLanguage, setPendingLanguage] = useState<string | null>(
    selectedLanguage || null
  );

  // Persist selection only on Continue
  const handleContinue = () => {
    if (!pendingLanguage) return;
    setSelectedLanguage(pendingLanguage);
    setLocalStorage(LANGUAGE, pendingLanguage);
    trackEvent("AA_Language_Selected", {
      "Login Mobile No": phoneNumber,
      "Clinic Id": agentDetails?.hm_id,
      "Clinic Name": agentDetails?.hospital_name,
      "Language Selected": pendingLanguage,
      "Time Stamp": dayjs().format("YYYY-MM-DD HH:mm:ss"),
    });
  };

  return (
    <div>
      <Drawer
        placement="bottom"
        open={true}
        height="auto"
        closeIcon={false}
        className="rounded-t-2xl overflow-hidden max-w-[450px] mx-auto"
        styles={{
          body: { padding: 0 },
        }}
      >
        <div className="">
          <div className="p-6 pb-2 bg-[#F7F3FC]">
            <div className="text-lg font-semibold pb-4">
              Select Preferred Language
            </div>
            <div
              className="space-y-3 overflow-y-auto"
              style={{ maxHeight: "410px" }}
            >
              {languageOptions.map((lang) => (
                <div
                  key={lang.value}
                  className={`p-4 rounded-xl cursor-pointer transition-all duration-200 ${
                    pendingLanguage === lang.value
                      ? "bg-[#4b4ad51a] border-[#4B4AD5] border-[1px]"
                      : "bg-white border-gray-200 hover:border-gray-300"
                  }`}
                  onClick={() => setPendingLanguage(lang.value)}
                >
                  <div className="flex items-center justify-between">
                    <h2 className="text-base font-semibold text-gray-900">
                      {lang.label}
                    </h2>
                    <div className="relative">
                      <span
                        className={`inline-flex items-center justify-center w-5 h-5 rounded-full border-2 ${
                          pendingLanguage === lang.value
                            ? "border-[#4B4AD5]"
                            : "border-[#4B4AD5]"
                        }`}
                        role="radio"
                        aria-checked={pendingLanguage === lang.value}
                      >
                        {pendingLanguage === lang.value && (
                          <span className="w-2.5 h-2.5 bg-[#4B4AD5] rounded-full" />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="px-6 py-4">
            <Button
              className={`flex justify-center overflow-hidden gap-2 self-stretch px-6 py-4 text-white bg-indigo-600 whitespace-nowrap rounded-2xl border border-indigo-600 border-solid w-full h-[50px] text-lg font-medium`}
              onClick={handleContinue}
              disabled={!pendingLanguage}
            >
              Continue
            </Button>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default SelectLanguageDrawer;
